/**
 * @file
 * Over scroll functionality.
 */

(($, { behaviors }, _) => {
  /**
   * Un-stick fixed elements.
   *
   * @param {jQuery} $topBar
   *   A top-bar DOM element.
   * @param {jQuery} $main
   *   A main DOM element.
   */
  function unstickFixedElements($topBar, $main) {
    $main.css("margin-top", "0");
    $topBar.removeClass("top-bar--fixed");
  }

  /**
   * Stick fixed elements.
   *
   * @param {jQuery} $topBar
   *   A top-bar DOM element.
   * @param {jQuery} $main
   *   A main DOM element.
   */
  function stickFixedElements($topBar, $main) {
    const topBarHeight = $topBar.outerHeight();
    const breakpointLarge = "(min-width: 1100px)";

    if (window.matchMedia(breakpointLarge).matches) {
      $main.css("margin-top", topBarHeight);
    } else {
      $main.css("margin-top", "0");
    }

    $topBar.addClass("top-bar--fixed");
  }

  /**
   * Initiates or disables header scroll behaviour.
   *
   * @param {function} cb
   *   The callback that handles the response.
   * @param {number} debounceTime
   *   Duration after which the function is run.
   */
  function onWindowResizeAndLoad(cb, debounceTime = 250) {
    const $window = $(window);
    $window.on(
      "resize",
      _.debounce(() => {
        cb();
      }, debounceTime)
    );
    cb();
  }

  /**
   * Attaches behaviors for over scroll.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches over scroll functionality.
   */
  behaviors.overScroll = {
    attach(context) {
      const $document = $(document);
      const $topBar = $(".js-top-bar", context);
      const $main = $(".js-main", context);
      const scrollThreshold = 0;
      const breakpointLarge = "(min-width: 1100px)";

      onWindowResizeAndLoad(() => {
        if (window.matchMedia(breakpointLarge).matches) {
          $document.on(
            "scroll",
            _.throttle(() => {
              // Un-stick fixed elements if the vertical offset is less than scroll threshold
              // or if the horizontal offset is not equal to scroll threshold and the user is
              // at the top of the document.
              if (
                window.pageYOffset < scrollThreshold ||
                (window.pageXOffset !== scrollThreshold &&
                  $(window).scrollTop() === scrollThreshold)
              ) {
                unstickFixedElements($topBar, $main);
              } else if (
                window.pageYOffset === scrollThreshold ||
                (window.pageXOffset === scrollThreshold &&
                  $(window).scrollTop() === scrollThreshold)
              ) {
                unstickFixedElements($topBar, $main);
              } else {
                stickFixedElements($topBar, $main);
              }
            }, 100)
          );
        } else {
          unstickFixedElements($topBar, $main);
        }
      });
    }
  };
})(jQuery, Drupal, _);
